export default __webpack_public_path__ + "static/media/1.5e57e929.jpg";